import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import FormAddEditWebhook from '../../components/webhooks/FormAddEditWebhook';

import { useGetWebhookById } from '../../hooks/webhooks/useGetWebhookById';
import { useUpdateWebhook } from '../../hooks/webhooks/useUpdateWebhook';

const EditWebhook = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');

    const { webhook, isLoading, error } = useGetWebhookById(id);
    const { updateWebhookAsync, isUpdating } = useUpdateWebhook();

    const handleSubmit = async (payload) => {
        try {
            await updateWebhookAsync({ id, data: payload });
            navigate(`/settings/integrations/webhooks/${id}`);
        } catch {
            // toast handled by hook
        }
    };

    if (isLoading) {
        return (
            <WrapperSection>
                <GlobalBreadcrumbs />
                <Box sx={{ p: 4, textAlign: 'center' }}>
                    <CircularProgress size={28} />
                </Box>
            </WrapperSection>
        );
    }

    if (error || !webhook) {
        return (
            <WrapperSection>
                <GlobalBreadcrumbs />
                <Alert severity="error">
                    {isArabic ? 'تعذر تحميل بيانات الـ Webhook' : 'Failed to load webhook'}
                </Alert>
            </WrapperSection>
        );
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <Box sx={{ mb: 2 }}>
                <Typography variant="h5" fontWeight={700}>
                    {isArabic ? 'تعديل Webhook' : 'Edit Webhook'}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {isArabic
                        ? 'يمكنك تعديل الاسم، الرابط، الأحداث المشترك بها، وحالة التفعيل. لتغيير السر استخدم زر "تدوير السر" في صفحة التفاصيل.'
                        : 'Update name, URL, subscribed events, and active state. To change the secret use the "Rotate secret" button on the detail page.'}
                </Typography>
            </Box>
            <FormAddEditWebhook
                mode="edit"
                webhook={webhook}
                onSubmit={handleSubmit}
                isSubmitting={isUpdating}
            />
        </WrapperSection>
    );
};

export default EditWebhook;
